import { createSelector } from 'reselect'

const getPayPalSettingsOptions: SelectOptionsSelector = (state) =>
  state.payPalSettings.payPalSettingsForOptions.map((item) => ({
    id: item.id,
    name: item.name
  })) || ([] as SelectOption[])

export const payPalSettingsSelectOptionsSelector: SelectOptionsSelector = createSelector(getPayPalSettingsOptions, (options) => options)
